export const GALLERY_HIGH = '1';
export const GALLERY_MEDIUM = '2';
export const GALLERY_LOW = '3';
export const MOVIE_4K = '4';
export const MOVIE_HD = '5';
export const MOVIE_SD = '6';
